import React, {useEffect, useRef} from 'react';
import FormBlock from "../../formComponents/FormBlock";
import BaseSimpleItemEditorForm from "../BaseSimplePage/BaseSimpleItemEditorForm";
import FormMultilineInput from "../../formComponents/FormMultilineInput";
import FormLinkedItemSelect from "../../formComponents/FormLinkedItemSelect";
import FormLinkedItemSimpleSelect from "../../formComponents/FormLinkedItemSimpleSelect";
import {allSchoolClasses} from "../../data/Enums";

const SchoolThemesItemForm = ({initData, controlRef}) => {

    const controlRefName = useRef(null);
    const controlRefSubject = useRef(null);
    const controlRefClass = useRef(null);

    useEffect(() => {
        if (controlRef) {
            controlRef.current = {
                validate: validate,
                getData: getData,
            };
        }
    });

    function validate() {
        let isValid = true;

        if (!controlRefName.current.validateNotEmpty("Нужно указать тему!"))
            isValid = false;

        if (!controlRefName.current.validateLength(255))
            isValid = false;

        if (!controlRefSubject.current.validateIsSelected("Нужно выбрать предмет!"))
            isValid = false;

        if (!controlRefClass.current.validateIsSelected("Нужно выбрать класс!"))
            isValid = false;

        return isValid;
    }

    function getData() {
        return {
            name: controlRefName.current.getText(),
            subject_id: controlRefSubject.current.getSelectedId(),
            class: controlRefClass.current.getSelectedId(),
        }
    }

    return (
        <BaseSimpleItemEditorForm>
            <FormBlock title="Основные">
                <FormMultilineInput
                    controlRef={controlRefName}
                    label="Тема"
                    widthLimit={700}
                    initValue={initData?.name ?? ""}
                    placeholder={"Название темы ..."}
                    maxVisibleRows={4}
                />
                <FormLinkedItemSelect
                    controlRef={controlRefSubject}
                    label="Предмет"
                    widthLimit={450}
                    initSelectedId={initData?.subject_id}
                    initRefList={initData?.refs?.subjects}
                    apiName2="school_subjects"
                    showIds={true}
                />
                <FormLinkedItemSimpleSelect
                    controlRef={controlRefClass}
                    label="Класс"
                    widthLimit={150}
                    initSelectedId={initData?.class}
                    options={allSchoolClasses}
                />
            </FormBlock>
        </BaseSimpleItemEditorForm>
    );
};

export default SchoolThemesItemForm;